export default {
  firstName({ commit }, firstName) {
    commit('setFirstName', firstName);
  },
  lastName({ commit }, lastName) {
    commit('setLastName', lastName);
  },
  email({ commit }, email) {
    commit('setEmail', email);
  },
  newsletterOptIn({ commit }, optIn) {
    commit('setNewsletterOptIn', optIn);
  },
  vehicleYear({ commit }, { id, label }) {
    commit('setYear', id);
    commit('setYearLabel', label);
  },
  vehicleMake({ commit }, { id, label }) {
    commit('setMake', id);
    commit('setMakeLabel', label);
  },
  vehicleModel({ commit }, { id, label }) {
    commit('setModel', id);
    commit('setModelLabel', label);
  },
  vehicleTrim({ commit }, { id, label }) {
    commit('setTrim', id);
    commit('setTrimLabel', label);
  },
  tireWidth({ commit }, tireWidth) {
    commit('setTireWidth', tireWidth);
  },
  tireAspect({ commit }, tireAspect) {
    commit('setTireAspect', tireAspect);
  },
  tireDiameter({ commit }, tireDiameter) {
    commit('setTireDiameter', tireDiameter);
  },
  tireName({ commit }, tireName) {
    commit('setTireName', tireName);
  },
  shirtSize({ commit }, shirtSize) {
    commit('setShirtSize', shirtSize);
  },
  hatSize({ commit }, hatSize) {
    commit('setHatSize', hatSize);
  },
  jacketSize({ commit }, jacketSize) {
    commit('setJacketSize', jacketSize);
  },
  addressLine1({ commit }, addressLine1) {
    commit('setAddressLine1', addressLine1);
  },
  city({ commit }, city) {
    commit('setCity', city);
  },
  state({ commit }, state) {
    commit('setState', state);
  },
  zipCode({ commit }, zipCode) {
    commit('setZipCode', zipCode);
  },
  phone({ commit }, phone) {
    commit('setPhone', phone);
  },
  enthusiastType({ commit }, enthusiastType) {
    commit('setEnthusiastType', enthusiastType);
  },
  additionalInfo({ commit }, additionalInfo) {
    commit('setAdditionalInfo', additionalInfo);
  },
  sessionId({ commit }, sessionId) {
    commit('setSessionId', sessionId);
  },
};
